<!-- Start your project here-->
<!-- <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner> -->


<div class="d-flex justify-content-center loader-background" *ngIf="isLoading$ | async">
  <!-- <div class="loader"></div> -->
  <div class="loader">
    <img src="../assets/CUBE-LOGO-ANIMATION.gif" class="img-responsive center-block text-center img-logo" alt="CUBE-logo" width="80" height="80"  />
    <!-- <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
    <h4> Loading...</h4> -->
  </div>
</div>

<div [ngClass]="theme$ | async">
  <app-navbar-sidebar *ngIf="showNavbar" style="height: 5%" (navCollapseOut)="isNavCollapse = $event" (outputVisibleNav)="visibleNav = $event" class="">
  </app-navbar-sidebar>
  
  <div class="row" style="height: 100%">
    <!-- <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 pl-0 pr-0 " *ngIf="visibleNav && !isNavCollapse">
    </div> -->
  
    <div style="height: 100%;" class="col-12" [class.cs-shell-content]="showNavbar">
      <!-- <p>
  
        {{'12345'|currency:"VEF":"symbol"}}
      </p> -->
        <router-outlet style="height: 100%;" class=""></router-outlet>
  
  
    </div>
  
  </div>
</div>

<!-- /end your project here-->
